<template>
  <v-switch v-model="excluded" :label="journey.name" @change="update"></v-switch>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'excluded-journey',
  props: ['journey', 'partner'],
  data: () => ({
    excluded: false
  }),
  computed: {
    ...mapGetters(['SelectedAccount'])
  },
  methods: {
    ...mapActions(['attachExcludedJourney', 'detachExcludedJourney']),
    update: function(value) {
      if (value === true) {
        this.attachExcludedJourney({
          id: this.partner.id,
          excludedJourneyId: this.journey.id
        });
      } else {
        this.detachExcludedJourney({
          id: this.partner.id,
          excludedJourneyId: this.journey.id
        });
      }
    }
  },
  watch: {
    partner: function() {
      this.excluded = _.filter(this.partner.excluded_journeys, journey => journey.id === this.journey.id).length > 0;
    }
  },
  mounted() {
    this.excluded = _.filter(this.partner.excluded_journeys, journey => journey.id === this.journey.id).length > 0;
  }
};
</script>

<style scoped></style>
